$(document).ready(function () {

    const storedPreferences = localStorage.getItem('cookiePreferences');
    if (storedPreferences) {
        const preferences = JSON.parse(storedPreferences);
    
        if (preferences.estatisticas || preferences.marketing) {
            cookieNotice.style.display = 'none';
        }
    }

    $('.form-validate').validate();

    $('.flexslider').flexslider({
        animation: "slide"
    });

    $('.flexslider-internal').flexslider({
        animation: "slide",
        controlNav: false,
        directionNav:false
    });

    masks();

    $.extend( $.validator.messages, {
        required: "Este campo &eacute; obrigat&oacute;rio.",
    } );

    setTimeout(function(){
        $(".cinema-image-not-found").each(function() {
            if (!this.complete || typeof this.naturalWidth == "undefined" || this.naturalWidth == 0) {
                $(this).attr('src', '/img/no-image-movie.png');
            }
        });
        
    }, 3000);
});

function masks(){
    var phoneMask = function (phone, e, currentField, options) {
        if (phone.length < 15) {
            return '(00) 0000-00009';
        }
        return '(00) 00000-0009';
    };

    $(".mask-phone").mask(phoneMask, {
        onKeyPress: function (phone, e, currentField, options) {
            $(currentField).mask(phoneMask(phone), options);
        }
    });

    $(".mask-cpf").mask("000.000.000-00");

    $('.select2').select2();
}

function showTrailer(trailer){
    if (trailer.indexOf("http") < 0){
        trailer = 'http://'+trailer
    }

    $('#content-trailer').attr('src', trailer);
    $('#show-trailer').modal('show');
}

function showSessions(id,element){
    $('.day.active').removeClass('active');
    $('.session.active').hide().removeClass('active');

    $('#'+id).fadeIn().addClass('active');

    $(element).addClass('active');
}

$('#show-trailer').on('hidden.bs.modal', function (e) {
    $('#content-trailer').attr('src', "");
})

$('.map').click(function () {
    $('.map iframe').css("pointer-events", "auto");
});

$('.map' ).mouseleave(function() {
    $('.map iframe').css("pointer-events", "none");
});

//Captcha
var check_captcha = false;

function captcha(form){
    $(form).submit(function (event) {
        if(check_captcha == false){
            event.preventDefault();
            $('#captcha-message').html('Preencha o Captcha');
        }
    });
}

var verifyCallback = function(response) {
    check_captcha = true;
    $('#captcha-message').remove();
};

var onloadCallback = function() {
    grecaptcha.render('captcha', {
        'sitekey' : '6Lcj3h8TAAAAAN__brxcmJzpKXtjydFms3Vr4RnU',
        'callback' : verifyCallback
    });
};

function getParameterByName(name) {
    var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

$('#newsletter-form').submit(function(event){
    event.preventDefault();

    var formData = new FormData($(this)[0]);
    
    $.ajax({
        type: "POST",
        url: '/contato/send-newsletter',
        data: formData,
        cache: false,
        contentType: false,
        processData: false,
        dataType: "json",
        success: function (data) {
            var message = '<a class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></a>'+data.msg;

            $('#message').html(message);

            if (!data.error) {
                $('#message').addClass('alert-success');
            }else{
                $('#message').addClass('alert-danger');
            }

            $('#message').show();
        }
    });    
     
});

function filterStores() {
    $('#search-segments').select2({placeholder: "Busque por segmento"});
    $('#search-store').select2({placeholder: "Busque por loja"});
}

var nextImg;
var previousImg;

function showImage(previous, element, next) {
    nextImg = next;
    previousImg = previous;

    $('#show-image img').attr('src',element);
    $('#show-image').modal('show');
}

function previousImgAction() {
    if(previousImg != undefined){
        var size = $('.list-gallery .owl-item').length;

        if (previousImg <= 0){
            previousImg = size;
        }

        var url = $('#image-'+previousImg).css("background-image");
        url = /^url\((['"]?)(.*)\1\)$/.exec(url);
        url = url ? url[2] : "";

        $('#show-image img').attr('src', url);

        nextImg = nextImg + 1;
        previousImg = previousImg - 1;

    }

}

function nextImgAction() {
    if(nextImg != undefined){
        var size = $('.list-gallery .owl-item').length;


        if (nextImg > size){
            nextImg = 1;
        }

        var url = $('#image-'+nextImg).css("background-image");
        url = /^url\((['"]?)(.*)\1\)$/.exec(url);
        url = url ? url[2] : "";

        $('#show-image img').attr('src', url);

        nextImg = nextImg + 1;
        previousImg = previousImg - 1;

    }
}

function getService(id) {
    if(id != null){
        $('html, body').animate({
            scrollTop: $("#servico-" + id).offset().top - 80
        }, 2000);
    }
}

// COOKIES
function confirmCookies() {
    const cookieOptions = {};

    const marketingCheckbox = document.querySelector('input[type="checkbox"][name="marketing"]');
    const estatisticasCheckbox = document.querySelector('input[type="checkbox"][name="estatisticas"]');

    if(marketingCheckbox.checked || estatisticasCheckbox.checked) {
        if (marketingCheckbox.checked) {
            cookieOptions['marketing'] = [marketingCheckbox.value];
        }
    
        if (estatisticasCheckbox.checked) {
            cookieOptions['estatisticas'] = [estatisticasCheckbox.value];
        }
        
        cookieOptions.data = new Date().toISOString();

        localStorage.setItem('cookiePreferences', JSON.stringify(cookieOptions));

        document.getElementById('cookieNotice').style.display = 'none';
    } else {
        document.getElementById('CookieWarning').style.visibility = 'visible';
    }
}

function denyCookies() {
    const cookiePreferences = {};
    cookiePreferences.estatisticas = '';
    cookiePreferences.marketing = '';
    cookiePreferences.data = new Date().toISOString();

    localStorage.setItem('cookiePreferences', JSON.stringify(cookiePreferences));
    document.getElementById('cookieNotice').style.display = 'none';
}

function allowAllCookies() {
    const marketingCheckbox = document.querySelector('input[type="checkbox"][name="marketing"]');
    const estatisticasCheckbox = document.querySelector('input[type="checkbox"][name="estatisticas"]');

    if (marketingCheckbox) {
        marketingCheckbox.checked = true;
    }

    if (estatisticasCheckbox) {
        estatisticasCheckbox.checked = true;
    }

    const cookieOptions = {
        marketing: marketingCheckbox ? [marketingCheckbox.value] : [],
        estatisticas: estatisticasCheckbox ? [estatisticasCheckbox.value] : [],
        data: new Date().toISOString(),
    };

    localStorage.setItem('cookiePreferences', JSON.stringify(cookieOptions));

    document.getElementById('cookieNotice').style.display = 'none';
}